<mat-menu #clickmenu="matMenu" class="popup-menu" >
  <div  class="flex-display justify-content-flex-end" >
    <button mat-icon-button class="height-24" aria-label="Close Button">
      <mat-icon class="close-footer-menu-icon ">close</mat-icon>
    </button>
  </div>
  <div *ngFor="let item of menuList" tabindex="0" >
    <button  role="menuitem" mat-menu-item (keyup.enter)="clickMenuItem(item)"
            *ngIf="item.value === undefined"
            (click)="clickMenuItem(item)"
            [disabled]="item.isDisabled" aria-label="item.menuLinkText"
            id="popup-menu-button" [ngClass]="item.isDisabled? 'disable-Action': ''">
      <img [src]="item.imgPath" class="icon-para-action" [alt]="item.menuLinkText">
      <span class="popup-menu-font">{{item.menuLinkText}}</span>
    </button>
    <button (click)="$event.stopPropagation();" mat-menu-item role="menuitem" (keydown.enter)="toggleByKeyboard(item)" tabindex="0" *ngIf="item.isToggle === true" class="custom-menu-item-container justify-content-space-between min-width-248 my-1">
      <img [src]="item.imgPath" class="icon-para-action" [alt]="item.menuLinkText">
      <span class="popup-menu-print-queue-font">{{item.menuLinkText}}</span>
      <mat-slide-toggle [ngClass]="item.value == 'showSources'?'ml-2-9':'ml-1'" (change)="toggle($event, item)" [checked]="item.value == 'showSources' ? showSourcesToggle : printqueueAdd" [(ngModel)]="item.value"></mat-slide-toggle>
    </button>
  </div>
</mat-menu>
<div role="region"  class="flex-display">
  <button mat-icon-button class="mat-icon-height"
          [matMenuTriggerFor]="clickmenu" aria-label="Feature Indicator" title="Paragraph Feature Indicator">
    <mat-icon>more_horiz</mat-icon>
  </button>

  <button tabindex="0" (keyup.enter)="deleteBookmark()" *ngIf="IsBookmark" mat-icon-button aria-label="Remove Bookmark" title="Remove Bookmark">
    <mat-icon (click)="deleteBookmark()" class="bookmarkremove"></mat-icon>
  </button>
  <button tabindex="0" (keyup.enter)="openAnnotations()" (click)="openAnnotations()" mat-icon-button *ngIf="annotationCount>0" aria-label="Your Annotation" title="Your Annotation">
    <mat-icon [matBadge]="annotationCount">check_box_outline_blank</mat-icon>
  </button>
  <div [id]="articleId" class="Print-Queue-icon" style="float:right;" *ngIf="menuListItems.length > 0 && printqueueAdd" title="Print Queue">
    <img src="../../../../assets/icons/print-queue-blue.svg" class="Print-Queue-icon-img" alt="printer" />
  </div>
</div>

